import { useMemo } from 'react';

export const usePublishedAdStatusColors = (status: number) => {
	const className = useMemo(() => {
		switch (status) {
			case 1:
				return {
					colors: 'bg-success-selected text-success-main',
					label: 'پذیرش شده',
				};
			case 0:
				return {
					colors: 'bg-error-selected text-error-main',
					label: 'رد شده',
				};
			default:
				return {
					colors: '',
					label: '',
				};
		}
	}, [status]);

	return className;
};
